/**
 * Copyright 2022 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { z } from "zod";

export const CustomerFormSchema = z.object({
  name: z.string().min(1, "Name is required."),
  rpo: z
    .number({
      required_error: "Min. RPO is required.",
      invalid_type_error: "Min. RPO is required.",
    })
    .gte(4, "Should be greater than or equal to 4"),
  primarySnapshotsRetentionQuantity: z
    .number({
      required_error:
        "Max. primary snapshots retention (quantity) is required.",
      invalid_type_error:
        "Max. primary snapshots retention (quantity) is required.",
    })
    .gte(1, "Should be greater than 0"),
  primarySnapshotsRetentionInDays: z
    .number({
      required_error: "Max. primary snapshots retention (days) is required.",
      invalid_type_error:
        "Max. primary snapshots retention (days) is required.",
    })
    .gte(1, "Should be greater than 0"),
  replicaSnapshotsRetentionQuantity: z
    .number({
      required_error:
        "Max. replica snapshots retention (quantity) is required.",
      invalid_type_error:
        "Max. replica snapshots retention (quantity) is required.",
    })
    .gte(1, "Should be greater than 0"),
  replicaSnapshotsRetentionInDays: z
    .number({
      required_error: "Max. replica snapshots retention (days) is required.",
      invalid_type_error:
        "Max. replica snapshots retention (days) is required.",
    })
    .gte(1, "Should be greater than 0"),
});

export type CustomerFormSchemaType = z.infer<typeof CustomerFormSchema>;
